var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68037 11.2859L7.68038 11.2859L11.6248 7.34146C11.088 7.11802 10.4522 6.751 9.85081 6.14966C9.24937 5.54822 8.88232 4.91227 8.6589 4.37537L4.71436 8.3199L4.71434 8.31993C4.40654 8.62773 4.25263 8.78164 4.12027 8.95134C3.96413 9.15152 3.83026 9.36812 3.72104 9.5973C3.62845 9.79159 3.55962 9.99808 3.42196 10.4111L2.69603 12.5888C2.62829 12.7921 2.68118 13.0161 2.83266 13.1676C2.98414 13.3191 3.20821 13.372 3.41144 13.3043L5.58922 12.5783C6.0022 12.4407 6.2087 12.3718 6.40298 12.2792C6.63216 12.17 6.84876 12.0362 7.04895 11.88C7.21864 11.7477 7.37257 11.5937 7.68037 11.2859Z",
    fill: "#FFB823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7194 6.24692C13.5384 5.42788 13.5384 4.09995 12.7194 3.28091C11.9003 2.46187 10.5724 2.46187 9.75336 3.28091L9.28027 3.75399C9.28675 3.77356 9.29347 3.79339 9.30044 3.81348C9.47385 4.31329 9.80102 4.9685 10.4165 5.58397C11.032 6.19944 11.6872 6.52662 12.187 6.70002C12.207 6.70696 12.2267 6.71365 12.2462 6.7201L12.7194 6.24692Z",
    fill: "#FFB823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.d8f513b9147b5697fad7e14ffb29ba98.svg";
export { ForwardRef as ReactComponent };